/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { INodeProps, Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IProductCollectionViewProps, IProductComponentViewProps, IProduct } from './fits-model-collection';

import { clsHelper } from '../../utilities/class-name-helper';

//==============================================================================
// CLASS NAME UTILITY
//==============================================================================
const BASE_CLASS = 'fits-model-collection';
const cls = (fragment?: string) => clsHelper(BASE_CLASS, fragment);

const ProductCollectionView: React.FC<IProductCollectionViewProps> = props => {
    const {
        heading,
        ProductCollectionContainer,
        products,
        GridComponentProps,
        productList
    } = props;

    if (products) {
        return (
            <Module {...ProductCollectionContainer}>
                {_renderGrid(heading, GridComponentProps, products, productList)}
            </Module>
        );
    }
    props.context.telemetry.error('Product collection content is empty, module wont render.');
    return null;
};

const _renderGrid = (heading: React.ReactNode, gridContainer: INodeProps, items: IProductComponentViewProps[], productList?: IProduct[]): JSX.Element => {
    return (
        <div className={BASE_CLASS}>
            {heading && <div className={cls('heading')}>{heading}</div>}
            <ul {...gridContainer} className={cls('items')}>
                {items && items.map((item, index) => _renderProduct(item, productList ? productList[index] : undefined))}
            </ul>
        </div>
    );
};

const _renderProduct = (product: IProductComponentViewProps, productName?: IProduct): JSX.Element => {
    const name = productName?.itemId;
    const url = productName?.url;

    return (
        <li className={cls('item')}>
            {<a href={url} className={cls('link')}>{name}</a>}
        </li>
    );
};

export default ProductCollectionView;
